import { Box, Container } from '@mui/material';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import Header from '@/components/common/Header';
import GAPageTracker from '@/components/GAPageTracker';
import HomePage from '@/pages/HomePage';
import FeaturesPage from '@/pages/FeaturesPage';
import OptionsFlowPage from '@/pages/OptionsFlowPage';
import TickerTrackingPage from '@/pages/TickerTrackingPage';
import BloggerTrackingPage from '@/pages/BloggerTrackingPage';
import ApiKeysPage from '@/pages/ApiKeysPage';
import FociPage from '@/pages/FociPage';

function App() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ color: 'text.secondary' }}>Loading...</Box>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <GAPageTracker />
      <Header />
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ticker-tracking" element={<TickerTrackingPage />} />
          <Route path="/channel-tracking" element={<BloggerTrackingPage />} />
          <Route path="/channel/:channelName" element={<HomePage />} />
          <Route path="/options-flow" element={<OptionsFlowPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/api-keys" element={<ApiKeysPage />} />
          <Route path="/foci" element={<FociPage />} />
          <Route path="/:date" element={<HomePage />} />
        </Routes>
      </Container>
    </Box>
  );
}

export default App;
